import { commonValidations } from '../../../../utils/validations';

export const signUpFormValidations = (isEn) => ({
  'email': commonValidations(isEn).email,
  'password': {
    required: isEn ? 'Please enter your password.' : '비밀번호를 입력해주세요.',
    minLength: {
      value: 8,
      message: isEn ? 'Password must be at least 8 characters.' : '비밀번호는 최소 8자 이상이어야 합니다.',
    },
    maxLength: {
      value: 12,
      message: isEn ? 'Password must be at most 12 characters.' : '비밀번호는 최대 12자까지 가능합니다.',
    },
    pattern: {
      value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      message: isEn
        ? 'Password must contain uppercase, lowercase, number, and special character.'
        : '비밀번호는 영문 대소문자, 숫자, 특수문자를 포함해야 합니다.',
    },
  },
  'passwordConfirm': {
    required: isEn ? 'Please confirm your password.' : '비밀번호 확인을 입력해주세요.',
    validate: (value, formValues) => {
      if (value !== formValues.password) {
        return isEn ? 'Passwords do not match.' : '비밀번호가 일치하지 않습니다.';
      }
      return true;
    },
  },
  'name': {
    required: isEn ? 'Please enter your name.' : '담당자명을 입력해주세요.',
    validate: (value) => {
      if (!value || value.trim().length === 0) {
        return isEn ? 'Please enter your name.' : '담당자명을 입력해주세요.';
      }
      return true;
    },
  },
  'phone': commonValidations(isEn).phone,
  'companyName': {
    required: isEn ? 'Please enter your company name.' : '기업명을 입력해주세요.',
    validate: (value) => {
      if (!value || value.trim().length === 0) {
        return isEn ? 'Please enter your company name.' : '기업명을 입력해주세요.';
      }
      return true;
    },
  },
  'ceoName': {
    required: isEn ? 'Please enter the CEO name.' : '대표자명을 입력해주세요.',
    validate: (value) => {
      if (!value || value.trim().length === 0) {
        return isEn ? 'Please enter the CEO name.' : '대표자명을 입력해주세요.';
      }
      return true;
    },
  },
  'businessNumber': {
    required: isEn ? 'Please enter your business registration number.' : '사업자 등록번호를 입력해주세요.',
    pattern: {
      value: /^[0-9]{0,10}$/,
      message: isEn
        ? 'Please enter a valid business registration number (numbers only, max 10 digits).'
        : '올바른 사업자 등록번호를 입력해주세요. (숫자만, 최대 10자)',
    },
    validate: (value) => {
      if (!value || value.trim().length === 0) {
        return isEn ? 'Please enter your business registration number.' : '사업자 등록번호를 입력해주세요.';
      }
      if (value.length !== 10) {
        return isEn ? 'Business registration number must be 10 digits.' : '사업자 등록번호는 10자리여야 합니다.';
      }
      return true;
    },
  },
  'businessFile': {
    required: isEn ? 'Please upload your business certificate.' : '사업자등록증을 업로드해주세요.',
    validate: (value) => {
      if (!value) {
        return isEn ? 'Please upload your business certificate.' : '사업자등록증을 업로드해주세요.';
      }
      return true;
    },
  },
  'address.addr1': {
    required: isEn ? 'Please enter your headquarters address.' : '본사 주소를 입력해주세요.',
    validate: (value) => {
      if (!value || (typeof value === 'object' && !value.formatted_address)) {
        return isEn ? 'Please enter your headquarters address.' : '본사 주소를 입력해주세요.';
      }
      return true;
    },
  },
  'site': {
    validate: (value) => {
      if (value && value.trim().length > 0) {
        const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
        if (!urlPattern.test(value)) {
          return isEn ? 'Please enter a valid URL.' : '올바른 URL을 입력해주세요.';
        }
      }
      return true;
    },
  },
  'fax': {
    pattern: {
      value: /^[0-9]{0,11}$/,
      message: isEn
        ? 'Please enter a valid fax number (numbers only, max 11 digits).'
        : '올바른 팩스 번호를 입력해주세요. (숫자만, 최대 11자)',
    },
  },
  'kyc.position': {
    required: isEn ? 'Please enter your position.' : '직위를 입력해주세요.',
    validate: (value) => {
      if (!value || value.trim().length === 0) {
        return isEn ? 'Please enter your position.' : '직위를 입력해주세요.';
      }
      return true;
    },
  },
  'kyc.role': {
    required: isEn ? 'Please enter your role.' : '역할을 입력해주세요.',
    validate: (value) => {
      if (!value || value.trim().length === 0) {
        return isEn ? 'Please enter your role.' : '역할을 입력해주세요.';
      }
      return true;
    },
  },
  'kyc.isRepOwns25': {
    validate: (value) => {
      // optional field
      return true;
    },
  },
  'kyc.isRepOnly25': {
    validate: (value) => {
      // optional field
      return true;
    },
  },
  'kyc.isOtherOwns25': {
    validate: (value) => {
      // optional field
      return true;
    },
  },
  'kyc.ownerList': {
    validate: (value) => {
      if (!value || !Array.isArray(value)) {
        return true; // optional
      }
      // ownerList 검증: isOtherOwns25가 true일 때 각 항목에 name과 position이 필요
      for (let i = 0; i < value.length; i++) {
        const item = value[i];
        if (!item.name || !item.name.trim()) {
          return isEn ? `Please enter the name for owner ${i + 1}.` : `소유자 ${i + 1}의 이름을 입력해주세요.`;
        }
        if (!item.position || !item.position.trim()) {
          return isEn ? `Please enter the position for owner ${i + 1}.` : `소유자 ${i + 1}의 직위를 입력해주세요.`;
        }
      }
      return true;
    },
  },
});
